import React from 'react'
import { Stack, Typography } from '@mui/material'
import T from 'prop-types'

export default function PageTitle({
  label = '',
  rightColumn,
  rightColumnProps,
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{ mb: 2.5 }}
      data-testid="page-title"
    >
      <div>
        {label &&
          (typeof label === 'string' ? (
            <Typography variant="h5">
              <strong>{label}</strong>
            </Typography>
          ) : (
            label
          ))}
      </div>
      <Stack direction="row" alignItems="center" {...rightColumnProps}>
        {rightColumn}
      </Stack>
    </Stack>
  )
}

PageTitle.propTypes = {
  label: T.oneOfType([T.string, T.object]).isRequired,
  rightColumn: T.node,
  rightColumnProps: T.object,
}
